import { EUnitOfMeasure } from '../shared/enum';
import { TInputScenario } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

export const vesselType: TInputScenario = 'vesselType';
export const propellerEquippedWithNozzles: TInputScenario = 'propellerEquippedWithNozzles';
export const effectivePowerUsedByThePropeller: TInputScenario = 'effectivePowerUsedByThePropeller';
export const coefficentC3: TInputScenario = 'coefficentC3';
export const verticalDistanceBetweenTheAxisOfThePropellerAndTheKell: TInputScenario = 'verticalDistanceBetweenTheAxisOfThePropellerAndTheKell';
export const draft: TInputScenario = 'draft';
export const vesselBeamBs: TInputScenario = 'vesselBeamBs';
export const propellerDistanceFromQuayL: TInputScenario = 'propellerDistanceFromQuayL';
export const horizontalDistanceBetweenPropellerAxisAndTheSlopeToe: TInputScenario = 'horizontalDistanceBetweenPropellerAxisAndTheSlopeToe';

export const scenarioPhysicalData = {
    [vesselType]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [propellerEquippedWithNozzles]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [effectivePowerUsedByThePropeller]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.power,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureMetricLabel.power,
        },
    },
    [coefficentC3]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [verticalDistanceBetweenTheAxisOfThePropellerAndTheKell]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [draft]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [vesselBeamBs]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [propellerDistanceFromQuayL]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [horizontalDistanceBetweenPropellerAxisAndTheSlopeToe]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
};
